/* @flow */

import {
  remove,
} from 'lodash/fp';
import dayjs from 'dayjs';
import { replaceAt } from 'find-and-replace-immutable';

import { UNDO_DELAY_IN_SECONDS } from '../../env';


const minDate = new Date(0);

export const INITIAL_STATE = {
  items: [],
  nextStatusChange: null,
  isFetching: false,
  lastFetchTime: null,
  isFetchRequestedByUser: false,
  undoValidUntil: minDate,
  undoItems: null,
};

export default (state: TodoState = INITIAL_STATE, action: LysterAction) => {
  if (action.type === 'SET_UNDO_CHECKPOINT') {
    return {
      ...state,
      undoText: action.payload.text,
      undoValidUntil: dayjs().add(UNDO_DELAY_IN_SECONDS, 'seconds').toDate(),
      undoItems: state.items,
    };
  } if (action.type === 'UNDO_LAST_ACTION') {
    if (
      state.undoValidUntil > new Date()
      && state.undoItems
    ) {
      return {
        ...state,
        items: state.undoItems,
        undoValidUntil: minDate,
        undoItems: null,
      };
    }

    return state;
  } if (action.type === 'TODO_UPDATE_NEXT_STATUS_CHANGE') {
    return { ...state, nextStatusChange: action.payload };
  } if (action.type === 'persist/REHYDRATE' && action.payload.todo) {
    const {
      items,
      lastFetchTime,
      undoValidUntil,
      nextStatusChange,
    } = action.payload.todo;

    if (items) {
      return {
        ...state,
        ...action.payload.todo,
        items,
        lastFetchTime: lastFetchTime ? new Date(lastFetchTime) : null,
        nextStatusChange: nextStatusChange
          ? new Date(nextStatusChange)
          : new Date(),
        undoValidUntil: undoValidUntil ? new Date(undoValidUntil) : minDate,
      };
    }
  } else if (action.type === 'GET_ALL_TODOS_SUCCEEDED') {
    const lastFetchTime = new Date(),
          items = action.payload.todos;

    return {
      ...state,
      items,
      isFetching: false,
      lastFetchTime,
    };
  } else if (action.type === 'GET_ALL_TODOS_REQUESTED') {
    const { isFetchRequestedByUser } = action.payload;

    return { ...state, isFetching: true, isFetchRequestedByUser };
  } else if (action.type === 'GET_ALL_TODOS_FAILED') {
    return { ...state, isFetching: false };
  } else if (action.type === 'LOGOUT_REQUEST') {
    return INITIAL_STATE;
  } else if (action.type === 'CLEAR_UNDO') {
    return {
      ...state,
      undoItems: null,
      undoValidUntil: minDate,
    };
  } else if (action.type === 'ADD_TODO_ROLLBACK') {
    const { meta } = action,
          items = remove(({ id }) => id === meta.id, state.items);

    return {
      ...state,
      items,
    };
  } else if (action.type === 'TODO_SYNC') {
    const item = action.payload,
          { items } = state;

    const previousItemIndex = items.findIndex((i) => i.id === item.id);

    return previousItemIndex > -1
      ? { ...state, items: replaceAt(previousItemIndex, item, items) }
      : { ...state, items: [...items, item] };
  } else if (action.type === 'ADD_TODO_COMMIT' || action.type === 'PATCH_TODO_COMMIT') {
    const { payload: { data } } = action,
          { items } = state;

    const previousItemIndex = items.findIndex((i) => i.id === data.id);

    return previousItemIndex > -1
      ? { ...state, items: replaceAt(previousItemIndex, data, items) }
      : { ...state, items: [...items, data] };
  }
  return state;
};
